import { render, staticRenderFns } from "./TypeUpdate.vue?vue&type=template&id=224a62cb&scoped=true&"
import script from "./TypeUpdate.vue?vue&type=script&lang=js&"
export * from "./TypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a62cb",
  null
  
)

export default component.exports